// src/pages/DocumentGenerator.tsx
import React, { useState } from 'react';
import { Card, Form, Input, Button } from 'antd';
import TemplateSelector from '../components/TemplateSelector.tsx';
import { mockTemplates } from '../data/mockTemplates.ts';

// 以下はダミーの生成関数（本来はLLM API呼び出し）
async function mockGenerateDocument(prompt: string, templateId?: string): Promise<string> {
  return `「${prompt}」に基づくドキュメント案\n選択テンプレート: ${templateId ?? 'なし'}`;
}

const DocumentGenerator: React.FC = () => {
  const [prompt, setPrompt] = useState('');
  const [selectedTemplate, setSelectedTemplate] = useState<string | undefined>();
  const [generatedContent, setGeneratedContent] = useState('');

  const handleGenerate = async () => {
    if (!prompt) return;
    const result = await mockGenerateDocument(prompt, selectedTemplate);
    setGeneratedContent(result);
  };

  return (
    <Card title="ドキュメント生成" style={{ margin: '20px' }}>
      <Form layout="vertical">
        <Form.Item label="プロンプト">
          <Input.TextArea
            rows={4}
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            placeholder="生成したい文書の要件やキーワードを入力"
          />
        </Form.Item>
        <Form.Item label="テンプレート選択">
          <TemplateSelector
            templates={mockTemplates}
            value={selectedTemplate}
            onChange={(val) => setSelectedTemplate(val)}
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" onClick={handleGenerate}>
            生成
          </Button>
        </Form.Item>
      </Form>

      {generatedContent && (
        <Card title="生成結果" style={{ marginTop: '20px' }}>
          <pre>{generatedContent}</pre>
        </Card>
      )}
    </Card>
  );
};

export default DocumentGenerator;
